import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useSessionStore } from '../../store/sessionStore';
import { useAuthStore } from '../../store/authStore';
import { apiClient } from '../../api/client';
import { useTranslation } from '../../i18n';
interface Tab {
  path: string;
  label: string;
  icon: string;
}



const ADMIN_TAB: Tab = { path: '/admin', label: 'Admin', icon: 'admin_panel_settings' };

export function BottomNav() {
  const navigate      = useNavigate();
  const { pathname }  = useLocation();
  const activeSession = useSessionStore((s) => s.activeSession);
  const isAdmin       = useAuthStore((s) => s.user?.is_admin ?? false);
  const { t }         = useTranslation();

  const BASE_TABS: Tab[] = [
    { path: '/',         label: t('home'),      icon: 'home' },
    { path: '/find',     label: t('find'),      icon: 'search' },
    { path: '/spots',    label: t('my_spots'),  icon: 'directions_car' },
    { path: '/requests', label: t('requests'),  icon: 'pending_actions' },
    { path: '/profile',  label: t('profile'),   icon: 'person' },
  ];
  
  const BASE_TABS_WITH_LABELS: Tab[] = [
    { path: '/',         label: t('home'),      icon: 'home' },
    { path: '/find',     label: t('find'),      icon: 'search' },
    { path: '/spots',    label: t('my_spots'),  icon: 'directions_car' },
    { path: '/requests', label: t('requests'),  icon: 'pending_actions' },
    { path: '/profile',  label: t('profile'),   icon: 'person' },
  ];

  const ADMIN_TAB_WITH_LABEL: Tab = { path: '/admin', label: t('admin'), icon: 'admin_panel_settings' };
  const TABS          = isAdmin ? [...BASE_TABS_WITH_LABELS.slice(0, -1), ADMIN_TAB_WITH_LABEL, BASE_TABS_WITH_LABELS[BASE_TABS_WITH_LABELS.length - 1]] : BASE_TABS_WITH_LABELS;

  const incomingRequestsQ = useQuery({
    queryKey: ['spot-requests', 'incoming'],
    queryFn: () =>
      apiClient
        .get<{ data: any[] }>('/spot-requests/incoming')
        .then((r) => r.data.data),
  });
  const hasIncomingRequests = (incomingRequestsQ.data?.length ?? 0) > 0;

  function isActive(path: string) {
    if (path === '/find') return pathname === '/find';
    if (path === '/spots') return pathname.startsWith('/spots');
    if (path === '/requests') return pathname.startsWith('/requests');
    if (path === '/profile') return pathname === '/profile';
    if (path === '/admin') return pathname.startsWith('/admin');
    return pathname === path;
  }

  return (
    <nav className="bottom-nav" style={{
      position: 'sticky',
      bottom:   0,
      left:     0,
      right:    0,
      height:   '80px',
      display:  'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0 8px 12px',
      gap: '4px',
      borderRadius: '20px 20px 0 0',
      boxShadow: '0 -8px 24px -4px rgba(43,52,55,0.04)',
      zIndex: 100,
      maxWidth: '100%',
      overflow: 'hidden',
    }}>
      {TABS.map((tab) => {
        const active = isActive(tab.path);

        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            style={{
              display:        'flex',
              flexDirection:  'column',
              alignItems:     'center',
              justifyContent: 'center',
              gap:            '4px',
              border:         'none',
              background:     active ? '#eff6ff' : 'none',
              cursor:         'pointer',
              color:          active ? '#1d4ed8' : '#94a3b8',
              borderRadius:   '12px',
              padding:        '6px 12px',
              position:       'relative',
              transition:     'transform 0.15s',
              flex:           '1 1 auto',
              minWidth:       '55px',
              maxWidth:       '85px',
              whiteSpace:     'nowrap',
            }}
          >
            {tab.path === '/' && activeSession && (
              <span style={{
                position:        'absolute',
                top:             '4px',
                right:           'calc(50% - 14px)',
                width:           '8px',
                height:          '8px',
                borderRadius:    '50%',
                backgroundColor: '#ea580c',
                border:          '2px solid #fff',
              }} />
            )}
            {tab.path === '/requests' && hasIncomingRequests && (
              <span style={{
                position:        'absolute',
                top:             '4px',
                right:           'calc(50% - 14px)',
                width:           '8px',
                height:          '8px',
                borderRadius:    '50%',
                backgroundColor: '#ea580c',
                border:          '2px solid #fff',
              }} />
            )}
            <span
              className="material-symbols-outlined"
              style={{
                fontSize: 'clamp(20px, 5vw, 24px)',
                fontVariationSettings: active ? "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24" : "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24",
                lineHeight: '1',
              }}
            >
              {tab.icon}
            </span>
            <span style={{
              fontFamily:    'var(--inter)',
              fontSize:      'clamp(9px, 2.5vw, 11px)',
              fontWeight:    500,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              lineHeight:    '1.2',
            }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
